import { SVGProps, Ref, forwardRef } from 'react';

export const SkillPieBaseSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M7 12c0-1.598.51-3.196 1.859-4.141L13 12l-4.141 4.141C7.51 15.196 7 13.598 7 12"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 12c0-4 2-8 8-8s8 4 8 8-2 8-8 8-8-4-8-8m1.8 0c0-1.733.437-3.272 1.333-4.348C7.98 6.635 9.433 5.8 12 5.8s4.02.835 4.867 1.852C17.763 8.728 18.2 10.267 18.2 12s-.437 3.272-1.333 4.348C16.02 17.365 14.567 18.2 12 18.2s-4.02-.835-4.867-1.852C6.237 15.272 5.8 13.733 5.8 12"
                fill="currentColor"
            />
        </g>
    </svg>
));
SkillPieBaseSize24Glyph.displayName = 'SkillPieBaseSize24Glyph';
